import { groupBy } from "lodash";

import { ICategoryTag, IPlace } from "types";

type Props = [ICategoryTag[], IPlace[]];
type GroupedResponse = { [categoryName: string]: IPlace[] };

export const groupByCategories = (...props: Props): GroupedResponse => {
  const [categories, places] = props;

  const tags = categories
    .map((category) => category.tags)
    .flat(1)
    .map((item) => item.name.toLowerCase());

  const grouped = groupBy(places, (place) => place.category);

  return Object.keys(grouped)
    .filter((key) => tags.includes(key.toLowerCase()))
    .reduce((current, key) => ({ ...current, [key]: grouped[key] }), {});
};

export const filterByCategories = (...props: Props) => {
  const [categories, places] = props;

  const tags = categories
    .map((category) => category.tags)
    .flat(1)
    .map((item) => item.name.toLowerCase());

  return places.filter((item) => tags.includes(item.category.toLowerCase()));
};

export const countInGroups = (group: GroupedResponse) => {
  return Object.keys(group).reduce(
    (current, key) => ({ ...current, [key]: group[key].length }),
    {}
  );
};
